/* Recipe Schema Generator — builds valid Schema.org Recipe JSON-LD
   from a recipe form, entirely client-side. No data leaves the browser. */
(function () {
  'use strict';

  var EXAMPLE = {
    name: 'Spicy Honey Hot Sauce Wings',
    description:
      'Crispy baked chicken wings tossed in a sticky honey hot sauce glaze.',
    image: 'https://example.com/images/honey-hot-sauce-wings.jpg',
    author: 'Recipe Kit',
    prep: '15',
    cook: '40',
    yield: '4 servings',
    category: 'Appetizer',
    cuisine: 'American',
    calories: '380',
    ratingValue: '4.8',
    ratingCount: '127',
    keywords: 'hot sauce wings, spicy wings, honey hot sauce',
    ingredients: [
      '2 lbs chicken wings',
      '1/3 cup honey',
      '1/4 cup hot sauce',
      '2 tbsp butter, melted',
      '1 tsp garlic powder',
      'Salt and pepper to taste'
    ].join('\n'),
    instructions: [
      'Preheat oven to 425F and line a baking sheet with foil.',
      'Pat the wings dry, then season with garlic powder, salt, and pepper.',
      'Bake for 40 minutes, flipping halfway, until crisp and golden.',
      'Whisk the honey, hot sauce, and melted butter into a glaze.',
      'Toss the hot wings in the glaze and serve immediately.'
    ].join('\n')
  };

  // 90 -> "PT1H30M", 20 -> "PT20M", blank/0 -> ""
  function minutesToISO(value) {
    var total = parseInt(value, 10);
    if (!total || total <= 0) return '';
    var hours = Math.floor(total / 60);
    var minutes = total % 60;
    return 'PT' + (hours ? hours + 'H' : '') + (minutes ? minutes + 'M' : '');
  }

  function lines(value) {
    return String(value || '')
      .split('\n')
      .map(function (line) { return line.trim(); })
      .filter(Boolean);
  }

  function commaList(value) {
    return String(value || '')
      .split(',')
      .map(function (item) { return item.trim(); })
      .filter(Boolean);
  }

  function calorieText(value) {
    var raw = String(value || '').trim();
    if (!raw) return '';
    if (/calorie/i.test(raw)) return raw;
    if (/\d/.test(raw)) return raw + ' calories';
    return raw;
  }

  function buildSchema(data) {
    var schema = { '@context': 'https://schema.org', '@type': 'Recipe' };

    if (data.name) schema.name = data.name;
    if (data.description) schema.description = data.description;

    var images = commaList(data.image);
    if (images.length) schema.image = images;

    if (data.author) {
      schema.author = { '@type': 'Person', name: data.author };
    }

    schema.datePublished = new Date().toISOString().slice(0, 10);

    var prep = minutesToISO(data.prep);
    var cook = minutesToISO(data.cook);
    var totalMinutes = (parseInt(data.prep, 10) || 0) + (parseInt(data.cook, 10) || 0);
    if (prep) schema.prepTime = prep;
    if (cook) schema.cookTime = cook;
    if (totalMinutes > 0) schema.totalTime = minutesToISO(totalMinutes);

    if (data['yield']) schema.recipeYield = data['yield'];
    if (data.category) schema.recipeCategory = data.category;
    if (data.cuisine) schema.recipeCuisine = data.cuisine;
    if (data.keywords) schema.keywords = data.keywords;

    var ingredients = lines(data.ingredients);
    if (ingredients.length) schema.recipeIngredient = ingredients;

    var steps = lines(data.instructions);
    if (steps.length) {
      schema.recipeInstructions = steps.map(function (step) {
        return { '@type': 'HowToStep', text: step };
      });
    }

    var calories = calorieText(data.calories);
    if (calories) {
      schema.nutrition = { '@type': 'NutritionInformation', calories: calories };
    }

    var ratingValue = parseFloat(data.ratingValue);
    var ratingCount = parseInt(data.ratingCount, 10);
    if (ratingValue && ratingCount > 0) {
      schema.aggregateRating = {
        '@type': 'AggregateRating',
        ratingValue: String(ratingValue),
        ratingCount: String(ratingCount)
      };
    }

    return schema;
  }

  // Count the recipe properties (everything except the two @ keys).
  function propertyCount(schema) {
    return Object.keys(schema).filter(function (key) {
      return key.charAt(0) !== '@' && key !== 'datePublished';
    }).length;
  }

  function wrapScript(schema) {
    return (
      '<script type="application/ld+json">\n' +
      JSON.stringify(schema, null, 2) +
      '\n<\/script>'
    );
  }

  function readinessChecks(data) {
    return [
      {
        label: 'Recipe name',
        ok: Boolean(String(data.name || '').trim()),
        note: 'required'
      },
      {
        label: 'Dish image URL',
        ok: commaList(data.image).length > 0,
        note: 'required'
      },
      {
        label: 'Ingredients',
        ok: lines(data.ingredients).length > 0,
        note: 'recommended'
      },
      {
        label: 'Step-by-step instructions',
        ok: lines(data.instructions).length > 0,
        note: 'recommended'
      },
      {
        label: 'Prep and cook times',
        ok: Boolean(minutesToISO(data.prep) && minutesToISO(data.cook)),
        note: 'recommended'
      },
      {
        label: 'Ratings',
        ok: Boolean(parseFloat(data.ratingValue) && parseInt(data.ratingCount, 10) > 0),
        note: 'optional'
      }
    ];
  }

  function init(root) {
    var form = root.querySelector('[data-ref="form"]');
    var codeEl = root.querySelector('[data-ref="code"]');
    var statusEl = root.querySelector('[data-ref="status"]');
    var checksEl = root.querySelector('[data-ref="checks"]');
    var copyBtn = root.querySelector('[data-ref="copy"]');
    var exampleBtn = root.querySelector('[data-ref="example"]');
    var clearBtn = root.querySelector('[data-ref="clear"]');
    if (!form || !codeEl || !statusEl) return;

    var fields = Array.prototype.slice.call(form.querySelectorAll('[data-sg]'));

    function readForm() {
      var data = {};
      fields.forEach(function (field) {
        data[field.getAttribute('data-sg')] = field.value;
      });
      return data;
    }

    function render() {
      var data = readForm();
      var schema = buildSchema(data);
      var checks = readinessChecks(data);
      var missingRequired = checks.filter(function (check) {
        return check.note === 'required' && !check.ok;
      });
      codeEl.textContent = wrapScript(schema);

      if (missingRequired.length) {
        statusEl.textContent =
          'Needs ' + missingRequired.map(function (check) { return check.label.toLowerCase(); }).join(' and ');
        statusEl.dataset.state = 'empty';
      } else if (!lines(data.ingredients).length || !lines(data.instructions).length) {
        statusEl.textContent =
          'Eligible basics set · add ingredients and steps';
        statusEl.dataset.state = 'warn';
      } else {
        statusEl.textContent =
          'Rich result ready · ' + propertyCount(schema) + ' properties';
        statusEl.dataset.state = 'ready';
      }

      if (checksEl) {
        checksEl.innerHTML = checks
          .map(function (check) {
            return (
              '<li data-state="' + (check.ok ? 'ready' : 'missing') + '">' +
              '<span>' + check.label + '</span>' +
              '<small>' + (check.ok ? 'included' : check.note) + '</small>' +
              '</li>'
            );
          })
          .join('');
      }
    }

    var renderTimer;
    form.addEventListener('input', function () {
      clearTimeout(renderTimer);
      renderTimer = setTimeout(render, 150);
    });

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var text = codeEl.textContent || '';
        function done() {
          var original = copyBtn.dataset.label || copyBtn.textContent;
          copyBtn.dataset.label = original;
          copyBtn.textContent = 'Copied';
          copyBtn.dataset.copied = 'true';
          if (window.posthog) window.posthog.capture('recipe_schema_copied');
          setTimeout(function () {
            copyBtn.textContent = original;
            delete copyBtn.dataset.copied;
          }, 2000);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(done, function () {
            fallbackCopy(text, done);
          });
        } else {
          fallbackCopy(text, done);
        }
      });
    }

    function fallbackCopy(text, done) {
      var area = document.createElement('textarea');
      area.value = text;
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      try {
        document.execCommand('copy');
        done();
      } catch (err) {
        /* clipboard unavailable — user can still select the code manually */
      }
      document.body.removeChild(area);
    }

    if (exampleBtn) {
      exampleBtn.addEventListener('click', function () {
        fields.forEach(function (field) {
          var key = field.getAttribute('data-sg');
          field.value = EXAMPLE[key] || '';
        });
        render();
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        fields.forEach(function (field) { field.value = ''; });
        render();
      });
    }

    render();
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.slice
      .call(document.querySelectorAll('[data-rk-schema-generator]'))
      .forEach(init);
  });
})();
